/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddUserToOrderDenylistRequest,
    ApplyPopStoreThemeRequest,
    BillingAddressItem,
    CreateAccountSessionRequest,
    CreateAccountSessionResponse,
    EnsureStripeAccountResponse,
    GetStripeConnectedAccountResponse,
    PatchPrivateProfileDto,
    PreviewPopStoreThemeRequest,
    PreviewPopStoreThemeResponse,
    UpdateOrderDenyRequest,
} from '../models';

export interface PrivateProfileApiControllerAddUserToOrderDenylistRequest {
    addUserToOrderDenylistRequest: AddUserToOrderDenylistRequest;
}

export interface PrivateProfileApiControllerApplyPopStoreThemeRequest {
    userId: string;
    applyPopStoreThemeRequest: ApplyPopStoreThemeRequest;
}

export interface PrivateProfileApiControllerCreateStripeAccountSessionRequest {
    userId: string;
    createAccountSessionRequest: CreateAccountSessionRequest;
}

export interface PrivateProfileApiControllerEnsureStripeAccountRequest {
    userId: string;
}

export interface PrivateProfileApiControllerGetBillingAddressesRequest {
    profileId: string;
}

export interface PrivateProfileApiControllerGetStripeConnectedAccountRequest {
    userId: string;
}

export interface PrivateProfileApiControllerPatchPrivateProfileRequest {
    profileId: string;
    patchPrivateProfileDto: PatchPrivateProfileDto;
}

export interface PrivateProfileApiControllerPreviewPopStoreThemeRequest {
    userId: string;
    previewPopStoreThemeRequest: PreviewPopStoreThemeRequest;
}

export interface PrivateProfileApiControllerRemoveUserFromOrderDenylistRequest {
    userId: string;
}

export interface PrivateProfileApiControllerResetNewOrderMessagesRequest {
    userId: string;
}

export interface PrivateProfileApiControllerUpdateOrderDenyRequest {
    userId: string;
    updateOrderDenyRequest: UpdateOrderDenyRequest;
}

/**
 * 
 */
export class PrivateProfileApi extends runtime.BaseAPI {

    /**
     */
    async privateProfileApiControllerAddUserToOrderDenylistRaw(requestParameters: PrivateProfileApiControllerAddUserToOrderDenylistRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.addUserToOrderDenylistRequest === null || requestParameters.addUserToOrderDenylistRequest === undefined) {
            throw new runtime.RequiredError('addUserToOrderDenylistRequest','Required parameter requestParameters.addUserToOrderDenylistRequest was null or undefined when calling privateProfileApiControllerAddUserToOrderDenylist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/order-denylist`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addUserToOrderDenylistRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async privateProfileApiControllerAddUserToOrderDenylist(requestParameters: PrivateProfileApiControllerAddUserToOrderDenylistRequest): Promise<void> {
        await this.privateProfileApiControllerAddUserToOrderDenylistRaw(requestParameters);
    }

    /**
     */
    async privateProfileApiControllerApplyPopStoreThemeRaw(requestParameters: PrivateProfileApiControllerApplyPopStoreThemeRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling privateProfileApiControllerApplyPopStoreTheme.');
        }

        if (requestParameters.applyPopStoreThemeRequest === null || requestParameters.applyPopStoreThemeRequest === undefined) {
            throw new runtime.RequiredError('applyPopStoreThemeRequest','Required parameter requestParameters.applyPopStoreThemeRequest was null or undefined when calling privateProfileApiControllerApplyPopStoreTheme.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/private-profiles/{userId}:applyTheme`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.applyPopStoreThemeRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async privateProfileApiControllerApplyPopStoreTheme(requestParameters: PrivateProfileApiControllerApplyPopStoreThemeRequest): Promise<void> {
        await this.privateProfileApiControllerApplyPopStoreThemeRaw(requestParameters);
    }

    /**
     */
    async privateProfileApiControllerCreateStripeAccountSessionRaw(requestParameters: PrivateProfileApiControllerCreateStripeAccountSessionRequest): Promise<runtime.ApiResponse<CreateAccountSessionResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling privateProfileApiControllerCreateStripeAccountSession.');
        }

        if (requestParameters.createAccountSessionRequest === null || requestParameters.createAccountSessionRequest === undefined) {
            throw new runtime.RequiredError('createAccountSessionRequest','Required parameter requestParameters.createAccountSessionRequest was null or undefined when calling privateProfileApiControllerCreateStripeAccountSession.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/private-profiles/{userId}:create-account-session`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createAccountSessionRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async privateProfileApiControllerCreateStripeAccountSession(requestParameters: PrivateProfileApiControllerCreateStripeAccountSessionRequest): Promise<CreateAccountSessionResponse> {
        const response = await this.privateProfileApiControllerCreateStripeAccountSessionRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async privateProfileApiControllerEnsureStripeAccountRaw(requestParameters: PrivateProfileApiControllerEnsureStripeAccountRequest): Promise<runtime.ApiResponse<EnsureStripeAccountResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling privateProfileApiControllerEnsureStripeAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/private-profiles/{userId}:get-connected-account-info`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async privateProfileApiControllerEnsureStripeAccount(requestParameters: PrivateProfileApiControllerEnsureStripeAccountRequest): Promise<EnsureStripeAccountResponse> {
        const response = await this.privateProfileApiControllerEnsureStripeAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async privateProfileApiControllerGetBillingAddressesRaw(requestParameters: PrivateProfileApiControllerGetBillingAddressesRequest): Promise<runtime.ApiResponse<Array<BillingAddressItem>>> {
        if (requestParameters.profileId === null || requestParameters.profileId === undefined) {
            throw new runtime.RequiredError('profileId','Required parameter requestParameters.profileId was null or undefined when calling privateProfileApiControllerGetBillingAddresses.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/private-profiles/{profileId}/billing-addresses`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters.profileId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async privateProfileApiControllerGetBillingAddresses(requestParameters: PrivateProfileApiControllerGetBillingAddressesRequest): Promise<Array<BillingAddressItem>> {
        const response = await this.privateProfileApiControllerGetBillingAddressesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async privateProfileApiControllerGetStripeConnectedAccountRaw(requestParameters: PrivateProfileApiControllerGetStripeConnectedAccountRequest): Promise<runtime.ApiResponse<GetStripeConnectedAccountResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling privateProfileApiControllerGetStripeConnectedAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/private-profiles/{userId}/stripe-connected-account`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async privateProfileApiControllerGetStripeConnectedAccount(requestParameters: PrivateProfileApiControllerGetStripeConnectedAccountRequest): Promise<GetStripeConnectedAccountResponse> {
        const response = await this.privateProfileApiControllerGetStripeConnectedAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async privateProfileApiControllerPatchPrivateProfileRaw(requestParameters: PrivateProfileApiControllerPatchPrivateProfileRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.profileId === null || requestParameters.profileId === undefined) {
            throw new runtime.RequiredError('profileId','Required parameter requestParameters.profileId was null or undefined when calling privateProfileApiControllerPatchPrivateProfile.');
        }

        if (requestParameters.patchPrivateProfileDto === null || requestParameters.patchPrivateProfileDto === undefined) {
            throw new runtime.RequiredError('patchPrivateProfileDto','Required parameter requestParameters.patchPrivateProfileDto was null or undefined when calling privateProfileApiControllerPatchPrivateProfile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/private-profiles/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters.profileId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchPrivateProfileDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async privateProfileApiControllerPatchPrivateProfile(requestParameters: PrivateProfileApiControllerPatchPrivateProfileRequest): Promise<void> {
        await this.privateProfileApiControllerPatchPrivateProfileRaw(requestParameters);
    }

    /**
     */
    async privateProfileApiControllerPreviewPopStoreThemeRaw(requestParameters: PrivateProfileApiControllerPreviewPopStoreThemeRequest): Promise<runtime.ApiResponse<PreviewPopStoreThemeResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling privateProfileApiControllerPreviewPopStoreTheme.');
        }

        if (requestParameters.previewPopStoreThemeRequest === null || requestParameters.previewPopStoreThemeRequest === undefined) {
            throw new runtime.RequiredError('previewPopStoreThemeRequest','Required parameter requestParameters.previewPopStoreThemeRequest was null or undefined when calling privateProfileApiControllerPreviewPopStoreTheme.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/private-profiles/{userId}:previewTheme`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.previewPopStoreThemeRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async privateProfileApiControllerPreviewPopStoreTheme(requestParameters: PrivateProfileApiControllerPreviewPopStoreThemeRequest): Promise<PreviewPopStoreThemeResponse> {
        const response = await this.privateProfileApiControllerPreviewPopStoreThemeRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async privateProfileApiControllerRemoveUserFromOrderDenylistRaw(requestParameters: PrivateProfileApiControllerRemoveUserFromOrderDenylistRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling privateProfileApiControllerRemoveUserFromOrderDenylist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/order-denylist/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async privateProfileApiControllerRemoveUserFromOrderDenylist(requestParameters: PrivateProfileApiControllerRemoveUserFromOrderDenylistRequest): Promise<void> {
        await this.privateProfileApiControllerRemoveUserFromOrderDenylistRaw(requestParameters);
    }

    /**
     */
    async privateProfileApiControllerResetNewOrderMessagesRaw(requestParameters: PrivateProfileApiControllerResetNewOrderMessagesRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling privateProfileApiControllerResetNewOrderMessages.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/private-profiles/{userId}:clearNewOrderMessages`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async privateProfileApiControllerResetNewOrderMessages(requestParameters: PrivateProfileApiControllerResetNewOrderMessagesRequest): Promise<void> {
        await this.privateProfileApiControllerResetNewOrderMessagesRaw(requestParameters);
    }

    /**
     */
    async privateProfileApiControllerUpdateOrderDenyRaw(requestParameters: PrivateProfileApiControllerUpdateOrderDenyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling privateProfileApiControllerUpdateOrderDeny.');
        }

        if (requestParameters.updateOrderDenyRequest === null || requestParameters.updateOrderDenyRequest === undefined) {
            throw new runtime.RequiredError('updateOrderDenyRequest','Required parameter requestParameters.updateOrderDenyRequest was null or undefined when calling privateProfileApiControllerUpdateOrderDeny.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/order-denylist/{userId}:updateOrderDeny`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateOrderDenyRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async privateProfileApiControllerUpdateOrderDeny(requestParameters: PrivateProfileApiControllerUpdateOrderDenyRequest): Promise<void> {
        await this.privateProfileApiControllerUpdateOrderDenyRaw(requestParameters);
    }

}
